import { DiseaseChoicesTranslations } from './types';

export const enChoiceTranslations: DiseaseChoicesTranslations = {
    title: "Include Diseases",
    selectAll: "Select All",
    noDiseasesSelected: "No diseases selected"
};